import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "reactstrap";
import SvgImage from "../../../../Icons/Icons";
import "./index.css";
import { useNavigate, useSearchParams } from "react-router-dom";

import SearchBar from "../../../../subComponents/searchbar";
import AddNewVendor from "../../../Components/AddNewVendor";
import {
  cleanVendorList,
  getVendorAction,
} from "../../../../../services/Store/Actions/beneficiaryAction";
import BulkFuelAllVendors from "../../../Components/BulkFuelAllVendors";
import BulkUpload from "../../../../subComponents/BulkUpload";
import { bulkFuelTransferUpload, bulkVendorSample } from "../../../../../services/Store/Actions/TripsAction";

function VendorList(props) {

  let [searchParams, setSearchParams] = useSearchParams();
  // searchParams.get("__firebase_request_key")

  const [offset, setOffset] = useState(parseInt(searchParams.get("offset")) || 0);
  const [addNew, setAddNew] = useState(false);
  const [fullVpa, setFullVpa] = useState(false);
  const { onClickItem } = props;
  const { vendorList, vendor } = useSelector((state) => state?.beneficiary);
  const count = vendor?.count;
  const [search, setSearch] = useState(searchParams.get("search") || "");

  const [openBulkFuelVendor, setOpenBulkFuelVendor] = useState(false);

  const closeBulkFuelVendor = () => {
    setOpenBulkFuelVendor(false);
    //setProceed(0);
    //console.log("closed");
  };

  function handleBulkFuelVendor() {
    setOpenBulkFuelVendor(!openBulkFuelVendor);
    //setProceed(0);
  }

  useEffect(() => {
    let timeout;
    if (search != "") {
      dispatch(
        getVendorAction({
          isLogipeVendor: "0",
          limit: 7,
          offset: offset,
          search: search
        })
      );
    }else{
      timeout = setTimeout(() => {
        dispatch(
          getVendorAction({
            isLogipeVendor: "0",
            limit: 7,
            offset: offset,
            search: search
          })
        );
      }, 500);
    }
    return () => {
      clearTimeout(timeout);
    }; 
  }, [search, offset]);

  const bulkTransferCall = (e)=>{
    // setLoader(true);
    dispatch(bulkFuelTransferUpload({file:e},(res)=>{
        console.log(res);
        // setLoader(false);
        // if(res.status==200){
        //     // const blob = new Blob([res?.data])
        //     // const link = document.createElement("a");
        //     // link.href = window.URL.createObjectURL(blob);
        //     // link.download = `responseFile.xls`; //name to changed here
        //     // link.click();
        //     notify3();
        // }else {
        //     toast.error(res.data?.message||"some error occured")
        // }
        
    }))
}

const downloadSalDisbursement = () => {
  dispatch(bulkVendorSample((res) => {
      console.log("downloadSalaryAction", res?.data)
      if (res?.status == 200) {
          window.open(res?.data?.data?.url)
      }
    }))
}

  const handlePrev = () => {
    if (offset >= 7) {
      setOffset(offset - 7);
      setSearchParams({ offset: offset - 7 });
      console.log("vendorList?.length", vendorList?.length, offset);
        dispatch(
          getVendorAction({
            isLogipeVendor: "0",
            limit: 7,
            offset: offset - 7,
            search: search
          })
        );
    }
  };
  const [access, setAccess] = useState(false);

  const { authUser } = useSelector((state) => state?.loginReducer);
  const { managerControlList } = useSelector((state) => state?.userManagement);

  useEffect(()=>{
    setAccess(authUser?.company?.isVendor && authUser?.user?.type==2?3: authUser?.company?.isVendor && managerControlList?.vendorAccess?managerControlList?.vendorAccess:0)
  },[authUser,managerControlList])
  const handleNext = () => {
    if (offset + 7 < count) {
      setOffset(offset + 7);
      setSearchParams({ offset: offset + 7 });
      console.log("vendorList?.length", vendorList?.length, offset);
      if (vendorList?.length == offset + 7) {
        dispatch(
          getVendorAction({
            isLogipeVendor: "0",
            limit: 7,
            offset: offset + 7,
            search: search
          })
        );
      }
    }
  };
  const dispatch = useDispatch();
  // useEffect(() => {
  //   console.log("-------------useEffect", vendorList);
  //     dispatch(
  //       getVendorAction({
  //         isLogipeVendor: "0",
  //         limit: 7,
  //         offset: offset,
  //         search: search
  //       })
  //     );
  // }, []);
  function findSearch() {

  }
  if (addNew) {
    return (
      <AddNewVendor
        backPress={() => {
          setAddNew(false);
        }}
      />
    );
  } else {
    return (
      <div className="vendorBg containerShadow">
        <div className="d-flex" style={{
          justifyContent : "space-between"
        }}>
          <div>
            <p className="vendor-List-title">Vendor List</p>
          </div>
          <div
            className="leftTopDiv"
            onClick={() => {
              setOpenBulkFuelVendor(true);
            }}
            style={{ margin: "10px", cursor: "pointer" }}
          >
            <div className="bulkSalarySvgHeading">
              <div
                style={{
                  backgroundColor: "#FFF",
                  padding: "4px",
                  borderRadius: "4px",
                  marginRight: "10px",
                }}
              >
                <SvgImage name="payBulkSalaryLogo" />
              </div>
              <div className="FontNS18">Bulk Fuel Transfers</div>
            </div>
            <SvgImage name="rightArrow" />
          </div>
        </div>
        <div className="vendor-search-bar-section row" >
          <div className="FUllListSearchBar col-9">
            <SearchBar
              placeholder="Search for vendors"
              height="46"
              value={search}
              onChange={(event) => {
                setSearch(event.target.value);
                setOffset(0);
                setSearchParams({ search: event.target.value, offset: 0 });
              }}
              autoFocus={true}
            />
          </div>
          <button
            className="greenOutlineButton col-3"
            onClick={() => {
              setAddNew(true);
            }}
            style={{
              paddingLeft: "1rem",
              paddingRight: "1rem",
              height: "46px",
            }}
            disabled={[3, "3"].includes(access) ? false : true}
          >
            <text
              style={{
                paddingTop: "1rem",
                paddingBottom: "1rem",
              }}
            >
              + Add New Vendor
            </text>
          </button>
        </div>

        <div className="table-for-Vendor">
          <Table className="vehicleAssignedHistory">
            <thead className="th" style={{ zIndex: 99 }}>
              <tr className="table-header-vendor-details">
                <th className="vendor-transaction-header">
                  Company / Vendor Name
                </th>
                <th className="vendor-transaction-header">Phone No.</th>
                <th className="vendor-transaction-header">UPI Handle</th>
                <th className="vendor-transaction-header">Account Number</th>
                <th className="vendor-transaction-header">Vendor Type</th>
                <th className="vendor-transaction-header">GST Number</th>
              </tr>
            </thead>
            {/* <div className="tbodyVehicle-div"> */}
            <tbody className="tbodyVendor" style={{ textDecoration: "none" }}>
              {vendorList?.map((items, i) => {
                console.log("-----------", i, items);
                return (
                  <>
                    <tr
                      className="table-row-vendor-details"
                      onClick={() => {
                        onClickItem(items);
                      }}
                    >
                      <td
                        className="col-2 pb-0 pt-0 "
                        style={{
                          verticalAlign: "middle",
                          borderRightWidth: 1,
                        }}
                      >
                        <div className="row">
                          <div className="col-4 greenCirleInitial">
                            {parseInt(offset) + i + 1}
                          </div>{" "}
                          <div
                            className="col-8"
                            style={{
                              verticalAlign: "middle",
                              alignSelf: "center",
                            }}
                          >
                            {items?.name || "---"}
                          </div>
                        </div>
                      </td>
                      <td
                        className="col-2 pb-0 pt-0 ps-2"
                        style={{
                          verticalAlign: "middle",
                          borderRightWidth: 1,
                        }}
                      >
                        {items?.phone || "---"}
                      </td>
                      <td
                        className="pb-0 pt-0 col-2 ps-2"
                        style={{
                          verticalAlign: "middle",
                          borderRightWidth: 1,
                        }}
                        onMouseEnter={() => {
                          setFullVpa(i);
                        }}
                        onMouseLeave={() => {
                          setFullVpa();
                        }}
                      >
                        {items?.vpaId
                          ? fullVpa == i
                            ? items?.vpaId
                            : items?.vpaId?.substring(0, 20)
                          : "---"}
                        {items?.vpaId && !fullVpa && items?.vpaId?.length > 20
                          ? "..."
                          : ""}
                      </td>
                      <td
                        className="pb-0 pt-0 col-2"
                        style={{
                          verticalAlign: "middle",
                          borderRightWidth: 1,
                        }}
                      >
                        {items?.bankAccountNumber || "---"}
                      </td>
                      <td
                        className="pb-0 pt-0 col-2"
                        style={{
                          verticalAlign: "middle",
                          borderRightWidth: 1,
                        }}
                      >
                        {items?.vendorType == 1
                          ? "Others"
                          : items?.vendorType == 2
                          ? "Fleet"
                          : items?.vendorType == 3
                          ? ""
                          : items?.vendorType == 4
                          ? "Fuel"
                          : "Others"}
                      </td>
                      <td
                        className="pb-0 pt-0 col-2"
                        style={{
                          verticalAlign: "middle",
                          borderRightWidth: 1,
                        }}
                      >
                        {items?.gstNumber || "---"}
                      </td>
                    </tr>
                  </>
                );
              })}
            </tbody>
            {/* </div> */}
          </Table>
          {/* {
            olderHistoryStatus?
            <div className="olderTransactions-div" onClick={handleOlderTransactions}>
            Older History
            </div>:
          <></>
          } */}
          <div className="row margin0 padding16">
            <div
              className="col-4"
              style={{
                textAlign: "right",
                paddingTop: "0.1rem",
                cursor: offset > 0 ? "pointer" : "no-drop",
                opacity: offset > 0 ? "1" : "0.5",
              }}
              onClick={handlePrev}
            >
              <SvgImage name="PrevArrow" />
            </div>
            <div
              className="col-1 greenFont semiBold heading4 padding0L"
              style={{
                textAlign: "right",
                paddingTop: "0.3rem",
                cursor: offset > 0 ? "pointer" : "no-drop",
                opacity: offset > 0 ? "1" : "0.5",
              }}
              onClick={handlePrev}
            >
              Previous
            </div>
            <div className="col-2 row margin0 justify-content-center">
              <div
                className="greenBoxCount Medium heading4 col-4"
                style={{
                  width: "2rem",
                  height: "2rem",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                {offset / 7 + 1}
              </div>
              <div
                className=" col-4 padding0R"
                style={{ paddingTop: "0.3rem", textAlign: "right" }}
              >
                of{" "}
                {count % 7 == 0
                  ? Math.floor(count / 7)
                  : Math.floor(count / 7 + 1)}
              </div>
            </div>
            <div
              className="col-1 greenFont semiBold heading4 padding0R"
              style={{
                textAlign: "left",
                paddingTop: "0.3rem",
                cursor: count - offset > 7 ? "pointer" : "no-drop",
                opacity: count - offset > 7 ? "1" : "0.5",
              }}
              onClick={handleNext}
            >
              Next
            </div>
            <div
              className="col-4 padding0L"
              style={{
                textAlign: "left",
                marginLeft: "-1rem",
                paddingTop: "0.1rem",
                cursor: count - offset > 7 ? "pointer" : "no-drop",
                opacity: count - offset > 7 ? "1" : "0.5",
              }}
              onClick={handleNext}
            >
              <SvgImage name="NextArrow" />
            </div>
          </div>
        </div>
        {
        openBulkFuelVendor ? <BulkUpload
        toggle={() => setOpenBulkFuelVendor(!openBulkFuelVendor)}
        modal={openBulkFuelVendor}
        setModal={setOpenBulkFuelVendor}
        type="1"
        mode = "bulkFuel"
        name = "Bulk Fuel Vendor"
        func = {(e) => {
          bulkTransferCall(e)
        }}
        sampleFunc = {() => {
          downloadSalDisbursement()
        }}
      /> : <></>
      }
      </div>
    );
  }
}
export default VendorList;
